import { c as _c } from "react/compiler-runtime";
import { UnreachableCaseError } from "@opensea/utils";
import { OverviewModuleCarousel } from "../../../OverviewModuleCarousel";
import { FeaturedCollectionsCarouselLayout } from "../FeaturedCollectionsCarousel/FeaturedCollectionsCarouselLayout";
import { FeaturedItemsCarouselLayout } from "../FeaturedItemsCarousel/FeaturedItemsCarouselLayout";
import { FreeformContentCarouselLayout } from "../FreeformContentCarousel/FreeformContentCarouselLayout";
import { TimelineContentBlockCarouselLayout } from "../TimelineContentBlockCarousel/TimelineContentBlockCarouselLayout";

// For sections that are passed to featured carousels (keep original GraphQL type)

export function ContentBlockCarouselLayout(t0) {
  const $ = _c(10);
  const {
    title,
    description,
    carouselType,
    sections,
    moduleIndex
  } = t0;
  let t1;
  if ($[0] !== carouselType || $[1] !== sections) {
    t1 = function renderChildren() {
      switch (carouselType) {
        case "FREEFORM":
          {
            return <FreeformContentCarouselLayout sections={sections} />;
          }
        case "TIMELINE":
          {
            return <TimelineContentBlockCarouselLayout sections={sections} />;
          }
        case "FEATURED_ITEMS":
          {
            return <FeaturedItemsCarouselLayout sections={sections} />;
          }
        case "FEATURED_COLLECTIONS":
          {
            return <FeaturedCollectionsCarouselLayout sections={sections} />;
          }
        default:
          {
            throw new UnreachableCaseError(carouselType);
          }
      }
    };
    $[0] = carouselType;
    $[1] = sections;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const renderChildren = t1;
  let t2;
  if ($[3] !== renderChildren) {
    t2 = renderChildren();
    $[3] = renderChildren;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== description || $[6] !== moduleIndex || $[7] !== t2 || $[8] !== title) {
    t3 = <OverviewModuleCarousel description={description} moduleIndex={moduleIndex} title={title}>{t2}</OverviewModuleCarousel>;
    $[5] = description;
    $[6] = moduleIndex;
    $[7] = t2;
    $[8] = title;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}